import * as React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Style from '../style/bottombar.module.scss'
import HomeTab from '../../../../assets/theme6/bottomBar/HomeTab';
import StoreTab from '../../../../assets/theme6/bottomBar/StoreTab';

const BottomBar = () => {
    const location = useLocation();

    const navigate = useNavigate()
    const isActive = (path) => {
        return location.pathname.includes(path);
    };
    const handleNavigation = (e) => {
        navigate(`/${e}`)
    }
    return(<></>)
    return (
        <>
            <div className={Style.bottom_container}>
                <div className={`${Style.tab_box} ${isActive('home-challenge') ? Style.activetab : ''}`}
                    onClick={() => handleNavigation("home-challenge")}>
                    <HomeTab width={20} height={20} fillColor={isActive('home-challenge') ? "#fff" : "#FA5743"} />
                </div>
                <div className={`${Style.tab_box} ${isActive('brandStore') ? Style.activetab : ''}`}
                 onClick={() => handleNavigation("brandStore")}>
                    <StoreTab width={20} height={20} fillColor={isActive('brandStore') ? "#fff" : "#FA5743"} />
                </div>
            </div>
        </>
    )
}


export default BottomBar